import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_GENERIC_APPOINTMENT } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IID_Generic_AppointmentState extends EntityState<IID_GENERIC_APPOINTMENT, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GENERIC_APPOINTMENT })
@InterfaceDataStore(InterfaceName.GENERIC_APPOINTMENT)
export class IID_Generic_AppointmentStore extends EntityStore<IID_Generic_AppointmentState> {

  constructor() {
    super([]);
  }

}
